<template>
  <article>
    <div class="filter">
      <div class="filter__item">
        <taskSelect v-model="filters.etid" :lists.sync="taskLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">广告名：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600" :summary-method="getSummaries" show-summary>
      <el-table-column prop="date" label="日期" width="" align="center">
      </el-table-column>
      <el-table-column prop="etid" label="任务ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="title" label="任务名" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="底价折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.min_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="用户折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="upload_ocount" label="报单订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="upload_payment" label="报单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="upload_commission" label="报单佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="invalid_ocount" label="丢单订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="invalid_payment" label="丢单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="apply_ocount" label="可提现订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="apply_commission" label="可提现金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="exchange_commission" label="打款金额" width="" align="center">
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {earnDayBase, earnPeriodDayBase} from '../../../api/api'
import taskSelect from '../../../components/data-select/taskSelect.vue'
export default {
  name: 'earnDayBase',
  components: {
    taskSelect
  },
  mixins: [mixinList],
  data () {
    return {
      lists: [],
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        etid: '',
        title: ''
      },
      taskLists: []
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!['date', 'etid', 'title', 'aver_discount', 'min_discount', 'discount'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      this.listLoading = true

      if (filters.title !== '') {
        params.title = filters.title
      }

      // 根据实际条件设置
      let condition = true

      if (filters.etid !== '') {
        params.etid = filters.etid
        condition = false
      }

      (condition ? earnDayBase : earnPeriodDayBase)(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.etid': 'getList',
    'filters.title': 'getList'
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/earn/earnDayBase.vue